import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@/shared/lib/redux';

import { ADMIN_API_URLS, adminApiWrapper } from '@/shared/api/admin';

import { ADMIN_ROUTES } from '@/shared/constants';

import { resetAdminSession } from '@/entities/admin-session';

/**
 * Хук выхода администратора
 */
export const useAdminLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  /**
   * Чистит локальное состояние админки
   */
  const resetLocalAdminState = () => {
    queryClient.cancelQueries({ queryKey: ['admin'] });
    queryClient.removeQueries({ queryKey: ['admin'] });
    dispatch(resetAdminSession());
    navigate(ADMIN_ROUTES.login, { replace: true });
  };

  /**
   * Выполняет выход администратора
   * @param skipRequest Не отправлять sign_out на сервер
   */
  const logout = async (skipRequest = false) => {
    if (!skipRequest) {
      await adminApiWrapper.delete(ADMIN_API_URLS.auth.sign_out);
    }

    resetLocalAdminState();
  };

  return logout;
};
